// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_emptyCard__RoUg- {
  border-style: dashed;
  width: 100%;
  min-height: 5.4rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: 0.6rem auto; }

.styles_actions__eZIMW {
  gap: 0.35rem;
  flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/EmptyActivityCard/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,YAAY;EACZ,cAAc,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.emptyCard {\n  border-style: dashed;\n  width: 100%;\n  min-height: 5.4rem;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  margin: 0.6rem auto;\n}\n\n.actions {\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyCard": `styles_emptyCard__RoUg-`,
	"actions": `styles_actions__eZIMW`
};
export default ___CSS_LOADER_EXPORT___;
